<template>
  <div class="container">
    <van-nav-bar :title="$t('authentication.title')">
      <template #left>
        <van-icon name="arrow-left" color="#fff" size="20"  @click="back()"></van-icon>
      </template>
    </van-nav-bar>
    <div class="rows" id="content">
        <div class="container_box">
          <div class="personinfo container" v-if="status==0">
            <div class="overlay">
              <img src="/img/user/nopass.png?t=1"/>
            </div>
            <div class="box boy">
              <div class="c1">
                <img src="/img/user/boy.png" class="image" />
              </div>
              <!---->
            </div>
            <div class="box girl">
              <div class="c1">
                <img src="/img/user/girl.png" />
              </div>
              <!---->
            </div>
           </div>
          <div class="personinfo container" v-if="status==1">
            <div class="overlay">
              <img src="/img/user/pass.png?t=1"/>
            </div>
            <div class="box boy">
              <div class="c2">
                <img :src="userinfo.man_avatar" class="image" />
              </div>
              <div class="name">{{userinfo.man_name}}</div>
            </div>
            <div class="box girl">
              <div class="c2">
                <img :src="userinfo.woman_avatar" />
              </div>
              <div class="name">{{userinfo.woman_name}}</div>
            </div>
          </div>
          <div class="personinfo2">
            <div class="title">{{ $t('authentication.match_authentication') }}</div>
            <div class="tab">
              <table style="width: 100%">
                <tr class="bt_header">
                  <td style="width: 10%">{{ $t('authentication.serial_number') }}</td>
                  <td style="width: 30%">{{ $t('authentication.payment_amount') }}</td>
                  <td style="width: 30%">{{ $t('authentication.withdrawal_amount') }}</td>
                  <td style="width: 20%"></td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>{{info.row1_1}}</td>
                  <td>{{info.row1_2}}</td>
                  <td style="margin: auto">
                    <div class="bt1">{{ $t('authentication.produce') }}</div>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>{{info.row2_1}}</td>
                  <td>{{info.row2_2}}</td>
                  <td>
                    <div class="bt1">{{ $t('authentication.produce') }}</div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="call">
            <button class="van-button van-button--info van-button--normal van-button--round" @click="goWithdraw()">
              <div class="van-button__content">
                <span class="van-button__text"> {{ $t('authentication.withdrawal_application') }} </span>
              </div>
            </button>
          </div>
          <div class="personinfo2">
            <div class="title">{{ $t('authentication.identity_authentication') }}</div>
            <div class="tab">
              <table style="width: 100%">
                <tr class="bt_header">
                  <td style="width: 10%">{{ $t('authentication.serial_number') }}</td>
                  <td style="width: 30%">{{ $t('authentication.payment_amount') }}</td>
                  <td style="width: 30%">{{ $t('authentication.withdrawal_amount') }}</td>
                  <td style="width: 20%"></td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>{{info.row3_1}}</td>
                  <td>{{info.row3_2}}</td>
                  <td style="margin: auto">
                    <div class="bt1">{{ $t('authentication.produce') }}</div>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>{{info.row4_1}}</td>
                  <td>{{info.row4_2}}</td>
                  <td>
                    <div class="bt1">{{ $t('authentication.produce') }}</div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="call">
            <button class="van-button van-button--info van-button--normal van-button--round" @click="goWithdraw()">
              <div class="van-button__content">
                <span class="van-button__text">{{ $t('authentication.withdrawal_application') }} </span>
              </div>
            </button>
          </div>
          <div class="personinfo2">
            <div class="title">{{ $t('authentication.safety_certification') }}</div>
            <div class="tab">
              <table style="width: 100%">
                <tr class="bt_header">
                  <td style="width: 10%">{{ $t('authentication.serial_number') }}</td>
                  <td style="width: 30%">{{ $t('authentication.payment_amount') }}</td>
                  <td style="width: 30%">{{ $t('authentication.withdrawal_amount') }}</td>
                  <td style="width: 20%"></td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>{{info.row5_1}}</td>
                  <td>{{info.row5_2}}</td>
                  <td style="margin: auto">
                    <div class="bt1">{{ $t('authentication.produce') }}</div>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>{{info.row6_1}}</td>
                  <td>{{info.row6_2}}</td>
                  <td>
                    <div class="bt1">{{ $t('authentication.produce') }}</div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="call">
            <button class="van-button van-button--info van-button--normal van-button--round" @click="goWithdraw()">
              <div class="van-button__content">
                <span class="van-button__text">{{ $t('authentication.withdrawal_application') }}</span>
              </div>
            </button>
          </div>
        </div>

    </div>
  </div>
</template>

<script>
import { changeMoney } from '@/common/function';

export default {
  data() {
    return {
      userinfo:[],
      status:0,
      info:{
        row1_1: this.$t("authentication.generating")+"...",
        row1_2: this.$t("authentication.generating")+"...",
        row2_1: this.$t("authentication.generating")+"...",
        row2_2: this.$t("authentication.generating")+"...",
        row3_1: this.$t("authentication.generating")+"...",
        row3_2: this.$t("authentication.generating")+"...",
        row4_1: this.$t("authentication.generating")+"...",
        row4_2: this.$t("authentication.generating")+"...",
        row5_1: this.$t("authentication.generating")+"...",
        row5_2: this.$t("authentication.generating")+"...",
        row6_1: this.$t("authentication.generating")+"...",
        row6_2: this.$t("authentication.generating")+"...",
        }
    };
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getRechargeRecord();
    }

  },
  methods: {
    back(){
      return window.history.back();
    },
    goWithdraw() {
      this.$router.push({path:'/Withdraw'})
    },
    getRechargeRecord(){
      this.$http({
        method: 'get',
        url: 'user_get_certification'
      }).then(res=>{
        if(res.code === 200){
          //if(res.data.status==1){
              this.userinfo = res.data;
              this.status = res.data.status;
              var row=[];
              row.row1_1 = res.data.row_1_1;
              row.row1_2 = res.data.row_1_2;
              row.row2_1 = res.data.row_2_1;
              row.row2_2 = res.data.row_2_2;
              row.row3_1 = res.data.row_3_1;
              row.row3_2 = res.data.row_3_2;
              row.row4_1 = res.data.row_4_1;
              row.row4_2 = res.data.row_4_2;
              row.row5_1 = res.data.row_5_1;
              row.row5_2 = res.data.row_5_2;
              row.row6_1 = res.data.row_6_1;
              row.row6_2 = res.data.row_6_2;
              this.info=row;
          //}
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  }
};
</script>

<style lang='less' scoped>
.van-nav-bar {
  height: 2.88rem;

  /deep/ .van-nav-bar__title{
    color: #fff;
    font-size: 1rem;
  }
  /deep/ .van-nav-bar__left{
    padding: 0 1rem;
  }
}
.container_box{
    background-color: #5731bc;
    overflow-x: hidden;
}
.personinfo{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    background-color: #8f65fe;
    border-radius: 0.5rem;
    margin: 0.625rem;
    padding: 0.625rem;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}
.overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    width: 5rem;
    height: 5rem;
    z-index: 2;
    text-align: center;
    padding: 10px;
    font-size: 14px;
}
.overlay img{
    width: 100%;
    border-radius: 100%;
    border: 5px solid hsla(0,0%,100%,.5);
}
.personinfo .box .c1{
    margin: auto;
    margin-top: 10px;
    background-color: #fff;
    height: 370px;
    overflow: hidden;
}
.personinfo .box .c1 img{
    display: block;
    margin: auto;
    padding-top: 10px;
    width: 70%;
}
.personinfo .box .c2{
    margin: auto;
    background-color: #fff;
    height: 350px;
    overflow: hidden;
}
.personinfo .box .c2 img{
    display: block;
    margin: auto;
    width: 100%;
}
.personinfo .box .name{
    color: #fff;
}
.personinfo .box{
    width: 48%;
    padding-bottom:1px;
}
.personinfo2{
    background-color: #8f65fe;
    margin: 0.625rem;
    padding: 0.625rem;
    border-radius: 0.5rem;
    margin-top: 2rem;
}
.title{
    font-size: 40px;
    font-weight: 700;
    background: -webkit-gradient(linear,left top,right top,from(gold),to(#fc0));
    background: linear-gradient(90deg,gold,#fc0);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 2px 2px 5px rgb(0 0 0 / 50%);
    text-align: center;
    width: 100%;
    padding-top: 10px;
}
.personinfo2 .tab{
    margin-top: 10px;
    color: #fff;
}
.bt_header{
    color: #dac7c7;
}
.call{
    margin: auto;
    width: 100%;
    text-align: center;
    margin-bottom: 40px;
}
.call .van-button{
    width: 40%;
}
.van-button--round {
    border-radius: 999px;
}
.van-button--normal {
    padding: 0 15px;
    font-size: 14px;
}
.van-button--info {
    color: #fff;
    background-color: #1989fa;
    border: 10px solid #1989fa;
}
.van-button {
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    height: 88px;
    margin: 0;
    padding: 0;
    font-size: 30px;
    line-height: 1.2;
    text-align: center;
    border-radius: 10px;
    cursor: pointer;
    -webkit-transition: opacity .2s;
    transition: opacity .2s;
    -webkit-appearance: none;
}
.van-button--info, .van-button--primary {
    border: none!important;
    background: -webkit-gradient(linear,left top,right top,from(#a082f0),to(#ea92cf))!important;
    background: linear-gradient(90deg,#a082f0,#ea92cf)!important;
    border-radius: 10px!important;
}
.tab table td {
    border-bottom: 1px dashed #989696;
}
.personinfo2 td{
    height: 2rem;
}
.personinfo2 .bt1{
    font-size: 14px;
    color: #fff;
    display: inline-block;
    width: 90%;
    background-color: #ea92cf;
    border-radius: 0.3125rem;
    text-align: center;
    margin: auto;
}

</style>
